import { useState } from 'react';
import { Form, Button, InputGroup,Alert } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import ApiUtil from '../../util/ApiUtil';
import ApiPath from '../../util/ApiPath';
import Swal from 'sweetalert2'

function CreatePassword({ email, handleClick }) {
    const { t } = useTranslation();
    const [validated, setValidated] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [msgConfirmPasswordError, setMsgConfirmPasswordError] = useState('');

    const [msgError, setMsgError] = useState('');

    const togglePasswordVisibility = (field) => {
        if (field === 'password') {
            setShowPassword(!showPassword);
        } else if (field === 'confirmPassword') {
            setShowConfirmPassword(!showConfirmPassword);
        }
    };
    const passwordRegex = /^.{6,}$/;

    const handleInputChange = (value, type) => {
        if (type === 'password') {
            setPassword(value);
            if (!value) {
                setPasswordError(true); // No error when input is empty
              } else {
                setPasswordError(passwordRegex.test(value) ? false : true);
              }
        } else if (type === 'confirmPassword') {
            setConfirmPassword(value);
            if (!value) {
                setConfirmPasswordError(true);
                setMsgConfirmPasswordError(t('Please confirm your password'));
            } else {
                setConfirmPasswordError(value !== password); // Error if passwords don't match
                setMsgConfirmPasswordError(value !== password ? t('Passwords do not match') : '')
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setPasswordError(!password);
            if (!confirmPassword) {
                setConfirmPasswordError(true);
                setMsgConfirmPasswordError(t('Please confirm your password'));
            } else {
                setConfirmPasswordError(confirmPassword !== password); // Error if passwords don't match
                setMsgConfirmPasswordError(confirmPassword !== password ? t('Passwords do not match') : '')
            }
            setValidated(false);
            return;
        }
        setValidated(true);
        let data = {
            "PreviousMethodName": "VerifyCode",
            "Email": email,
            "NewPassword": password,
            "ConfirmPassword": confirmPassword
        }
        const res = await ApiUtil.postApi(ApiPath.ADD_NEW_PASSWORD,data, 'POST');       
        if (res.IsSuccessfull) {
            Swal.fire({
                icon: "success",
                text: t('New password created successfully'),
                showConfirmButton: false,
                timer: 4000
            });
            setTimeout(() => {
                window.location.reload();
            }, 4500)
        } else {
            setMsgError(res.Errors[0].Message)
        }
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <p className="text-center">
                {t('Your new password must be different from previously used passwords.')}
            </p>

            {/* Password Field */}
            <Form.Group className="mb-3" controlId="formGroupPassword">
                <Form.Label className="font-SemiBold">{t("Password")}</Form.Label>
                <InputGroup>
                    <Form.Control
                        type={showPassword ? 'text' : 'password'}
                        placeholder={t("Enter New Password")}
                        value={password}
                        onChange={(e) => handleInputChange(e.target.value, 'password')}
                        isInvalid={passwordError}
                        isValid={password && !passwordError}
                        required
                    />
                    <div
                        className={`btn-input-group`}
                        onClick={() => togglePasswordVisibility('password')}
                    >
                        {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                    </div>
                    <Form.Control.Feedback type="invalid">
                    {passwordError ? t("Password must be at least 6 characters long") : t("Please enter") + " " + t("Password")}
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>

            {/* Confirm Password Field */}
            <Form.Group className="mb-3" controlId="formGroupConfirmPassword">
                <Form.Label className="font-SemiBold">{t("Confirm Password")}</Form.Label>
                <InputGroup>
                    <Form.Control
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder={t("Confirm New Password")}
                        value={confirmPassword}
                        onChange={(e) => handleInputChange(e.target.value, 'confirmPassword')}
                        isInvalid={confirmPasswordError}
                        isValid={confirmPassword && !confirmPasswordError}
                        required
                    />
                    <div
                        className={`btn-input-group `}
                        onClick={() => togglePasswordVisibility('confirmPassword')}
                    >
                        {showConfirmPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                    </div>
                    <Form.Control.Feedback type="invalid">
                        {msgConfirmPasswordError}
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>

            <Button aria-label="Aria label" type="submit" className="btn-main w-100">
                {t("Send")}
            </Button>
            {msgError !== '' && <Alert variant={'danger'} className="mt-3 py-2">{t(msgError)}</Alert>}

        </Form>
    );
}

export default CreatePassword;
